import React from 'react';
import { motion } from 'framer-motion';
import { Star, CheckCircle2, MessageSquareIcon } from 'lucide-react';
export function ReviewsSection() {
  return <section className="py-28 md:py-32 bg-slate-50 text-slate-900 relative overflow-hidden" data-id="element-311">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-312">
        <div className="text-center mb-20" data-id="element-313">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex items-center justify-center gap-3 mb-6" data-id="element-314">
            <MessageSquareIcon className="w-8 h-8 text-brand-500" data-id="element-315" />
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-slate-900" data-id="element-316">
              Weitere Erfahrungsberichte
            </h2>
          </motion.div>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-slate-500 max-w-2xl mx-auto text-lg" data-id="element-317">
            Echte Geschichten von Männern, die ihre Nachtruhe zurückgewonnen
            haben.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10" data-id="element-318">
          {/* Review 1: Long-term user */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0
        }} className="bg-white p-8 md:p-10 rounded-2xl border-l-4 border-l-brand-500 border border-slate-200 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-319">
            <div className="flex gap-1 text-amber-400 mb-4" data-id="element-320">
              <Star className="w-5 h-5 fill-current" data-id="element-321" />
              <Star className="w-5 h-5 fill-current" data-id="element-322" />
              <Star className="w-5 h-5 fill-current" data-id="element-323" />
              <Star className="w-5 h-5 fill-current" data-id="element-324" />
              <Star className="w-5 h-5 fill-current" data-id="element-325" />
            </div>

            <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-326">
              "Nach 6 Monaten: Mein Leben hat sich verändert"
            </h3>

            <p className="text-slate-600 leading-relaxed mb-6 text-base" data-id="element-327">
              Ich nehme UroNacht jetzt seit einem halben Jahr und kann nur
              sagen: Es funktioniert. Am Anfang war ich skeptisch — ich hatte
              schon so viele Produkte probiert. Aber nach etwa 4 Wochen merkte
              ich den Unterschied. Heute schlafe ich die meisten Nächte komplett
              durch. Wenn ich doch mal aufwache, dann höchstens einmal. Meine
              Energie tagsüber ist wieder da, und meine Frau sagt, ich sei wie
              ausgewechselt. Die Investition lohnt sich absolut.
            </p>

            <div className="flex items-center gap-4 pt-6 border-t border-slate-100" data-id="element-328">
              <div className="w-12 h-12 rounded-full bg-brand-50 border border-brand-200 flex items-center justify-center text-brand-600 font-serif font-bold" data-id="element-329">
                HP
              </div>
              <div data-id="element-330">
                <p className="font-bold text-slate-900" data-id="element-331">Hans-Peter W., 67</p>
                <p className="text-sm text-slate-500 mb-1" data-id="element-332">Hamburg</p>
                <div className="flex items-center gap-1.5" data-id="element-333">
                  <CheckCircle2 className="w-3.5 h-3.5 text-brand-500" data-id="element-334" />
                  <span className="text-xs text-brand-500 uppercase tracking-wide font-medium" data-id="element-335">
                    Verifizierter Käufer
                  </span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Review 2: Tried other products */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white p-8 md:p-10 rounded-2xl border-l-4 border-l-brand-500 border border-slate-200 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-336">
            <div className="flex gap-1 text-amber-400 mb-4" data-id="element-337">
              <Star className="w-5 h-5 fill-current" data-id="element-338" />
              <Star className="w-5 h-5 fill-current" data-id="element-339" />
              <Star className="w-5 h-5 fill-current" data-id="element-340" />
              <Star className="w-5 h-5 fill-current" data-id="element-341" />
              <Star className="w-5 h-5 fill-current" data-id="element-342" />
            </div>

            <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-343">
              "Endlich ein Produkt, das hält was es verspricht"
            </h3>

            <p className="text-slate-600 leading-relaxed mb-6 text-base" data-id="element-344">
              Vor UroNacht habe ich bestimmt fünf verschiedene
              Prostata-Präparate ausprobiert. Keines hat wirklich geholfen. Der
              Unterschied bei UroNacht? Die Dosierung. 640 mg Sägepalme — das
              ist mehr als doppelt so viel wie bei den meisten anderen
              Produkten. Und man merkt es. Nach 3 Wochen ging es mir deutlich
              besser. Der Harndrang nachts ist von 4-5 Mal auf 1-2 Mal gesunken.
              Ich kann es nur empfehlen.
            </p>

            <div className="flex items-center gap-4 pt-6 border-t border-slate-100" data-id="element-345">
              <div className="w-12 h-12 rounded-full bg-brand-50 border border-brand-200 flex items-center justify-center text-brand-600 font-serif font-bold" data-id="element-346">
                MK
              </div>
              <div data-id="element-347">
                <p className="font-bold text-slate-900" data-id="element-348">Manfred K., 59</p>
                <p className="text-sm text-slate-500 mb-1" data-id="element-349">Frankfurt am Main</p>
                <div className="flex items-center gap-1.5" data-id="element-350">
                  <CheckCircle2 className="w-3.5 h-3.5 text-brand-500" data-id="element-351" />
                  <span className="text-xs text-brand-500 uppercase tracking-wide font-medium" data-id="element-352">
                    Verifizierter Käufer
                  </span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Review 3: Spouse perspective */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white p-8 md:p-10 rounded-2xl border-l-4 border-l-brand-500 border border-slate-200 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-353">
            <div className="flex gap-1 text-amber-400 mb-4" data-id="element-354">
              <Star className="w-5 h-5 fill-current" data-id="element-355" />
              <Star className="w-5 h-5 fill-current" data-id="element-356" />
              <Star className="w-5 h-5 fill-current" data-id="element-357" />
              <Star className="w-5 h-5 fill-current" data-id="element-358" />
              <Star className="w-5 h-5 fill-current" data-id="element-359" />
            </div>

            <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-360">
              "Mein Mann schläft endlich wieder durch — und ich auch"
            </h3>

            <p className="text-slate-600 leading-relaxed mb-6 text-base" data-id="element-361">
              Ich habe UroNacht für meinen Mann bestellt, weil sein ständiges
              Aufstehen nachts uns beide um den Schlaf gebracht hat. Nach Jahren
              des Leidens wollte er nichts mehr probieren, aber ich habe ihn
              überzeugt. Jetzt, nach 2 Monaten, sind wir beide überglücklich. Er
              steht vielleicht noch einmal auf, aber das ist nichts im Vergleich
              zu früher. Wir sind beide ausgeruhter und unsere Beziehung hat
              sich verbessert.
            </p>

            <div className="flex items-center gap-4 pt-6 border-t border-slate-100" data-id="element-362">
              <div className="w-12 h-12 rounded-full bg-brand-50 border border-brand-200 flex items-center justify-center text-brand-600 font-serif font-bold" data-id="element-363">
                IS
              </div>
              <div data-id="element-364">
                <p className="font-bold text-slate-900" data-id="element-365">Ingrid S., 61</p>
                <p className="text-sm text-slate-500 mb-1" data-id="element-366">Düsseldorf</p>
                <div className="flex items-center gap-1.5" data-id="element-367">
                  <CheckCircle2 className="w-3.5 h-3.5 text-brand-500" data-id="element-368" />
                  <span className="text-xs text-brand-500 uppercase tracking-wide font-medium" data-id="element-369">
                    Verifizierter Käufer
                  </span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Review 4: Younger user */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-white p-8 md:p-10 rounded-2xl border-l-4 border-l-brand-500 border border-slate-200 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-370">
            <div className="flex gap-1 text-amber-400 mb-4" data-id="element-371">
              <Star className="w-5 h-5 fill-current" data-id="element-372" />
              <Star className="w-5 h-5 fill-current" data-id="element-373" />
              <Star className="w-5 h-5 fill-current" data-id="element-374" />
              <Star className="w-5 h-5 fill-current" data-id="element-375" />
              <Star className="w-5 h-5 fill-current" data-id="element-376" />
            </div>

            <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-377">
              "Mit 48 dachte ich, das sei noch zu früh für solche Probleme"
            </h3>

            <p className="text-slate-600 leading-relaxed mb-6 text-base" data-id="element-378">
              Als die Probleme anfingen, war ich erst 46. Ich dachte, das
              betrifft nur ältere Männer. Mein Arzt meinte, es sei normal und
              ich solle damit leben. Das wollte ich nicht akzeptieren. Nach
              eigener Recherche bin ich auf UroNacht gestoßen. Die
              wissenschaftliche Fundierung hat mich überzeugt. Heute, zwei Jahre
              später, nehme ich es immer noch täglich. Meine Lebensqualität ist
              zurück, und ich fühle mich wieder wie ich selbst.
            </p>

            <div className="flex items-center gap-4 pt-6 border-t border-slate-100" data-id="element-379">
              <div className="w-12 h-12 rounded-full bg-brand-50 border border-brand-200 flex items-center justify-center text-brand-600 font-serif font-bold" data-id="element-380">
                SB
              </div>
              <div data-id="element-381">
                <p className="font-bold text-slate-900" data-id="element-382">Stefan B., 48</p>
                <p className="text-sm text-slate-500 mb-1" data-id="element-383">Berlin</p>
                <div className="flex items-center gap-1.5" data-id="element-384">
                  <CheckCircle2 className="w-3.5 h-3.5 text-brand-500" data-id="element-385" />
                  <span className="text-xs text-brand-500 uppercase tracking-wide font-medium" data-id="element-386">
                    Verifizierter Käufer
                  </span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}